var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import Button from "@/components/ui/button/Button.vue";
import ContextMenu from "@/components/ui/context-menu/ContextMenu.vue";
import { ChevronDownIcon, DownloadIcon } from "lucide-vue-next";
import { computed } from "vue";
import { exportData } from "./api";
import { exportEvents } from "./export-events";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExportButton',
    props: {
        data: { type: Array, required: true },
        fields: { type: Array, required: true },
        filename: { type: String, required: false, default: "export" },
        disabled: { type: Boolean, required: false, default: false },
        placement: { type: String, required: false, default: "bottom-end" }
    },
    emits: ["export-success", "export-error", "export-started"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const exportMenuOptions = computed(() => [
            {
                label: "Excel (.xlsx)",
                value: "xlsx",
            },
            {
                label: "PDF (.pdf)",
                value: "pdf",
            },
        ]);
        const handleSelect = (option) => __awaiter(this, void 0, void 0, function* () {
            const format = option.value;
            try {
                const response = yield exportData({
                    format,
                    fields: props.fields,
                    data: props.data,
                    filename: `${props.filename}.${format}`,
                });
                if (format === "pdf" && response) {
                    // PDF export is async - emit started event and notify dropdown
                    const pdfResponse = response;
                    exportEvents.emitExportStarted();
                    emit("export-started", "pdf", pdfResponse.export_id);
                }
                else {
                    emit("export-success", format);
                }
            }
            catch (error) {
                const errorMessage = `Error al exportar a ${format === "xlsx" ? "Excel" : "PDF"}. Por favor, intenta de nuevo.`;
                emit("export-error", errorMessage);
            }
        });
        const __returned__ = { props, emit, exportMenuOptions, handleSelect, Button, ContextMenu, get ChevronDownIcon() { return ChevronDownIcon; }, get DownloadIcon() { return DownloadIcon; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
